<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDetail" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Fiche de Validation devis / facture fournisseur</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations générales sur devis / facture
                                            </v-alert>
                                            <v-card flat>
                                                <v-layout wrap>
                                                    <v-card-text>
                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs3>Réference de la facture</v-flex>
                                                                            <v-flex xs9 class="text-xs-right title">
                                                                                {{factureDetail.ref}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs2>Libelle</v-flex>
                                                                            <v-flex xs10 class="text-xs-right title">
                                                                                {{factureDetail.libelle}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs3>Date de création de la facture</v-flex>
                                                                            <v-flex xs9 class="text-xs-right title">
                                                                                {{factureDetail.date}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row v-show="factureDetail.chantier !=''">
                                                                            <v-flex xs3>Projet / Chantier</v-flex>
                                                                            <v-flex xs9 class="text-xs-right title">
                                                                               {{factureDetail.projet}} / {{factureDetail.chantier}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-layout row v-show="factureDetail.libEntrepot">
                                                                            <v-flex xs2>Entrepot</v-flex>
                                                                            <v-flex xs12 class="text-xs-right title">
                                                                               {{factureDetail.libEntrepot}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row>
                                                                            <v-flex xs6>Emetteur de la facture</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.emetteurFacture}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de paiement</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.datePaiement}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                         <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row v-if="factureDetail.modifiedCommande != null">
                                                                            <v-flex xs6>Date de modification de la commande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.modifiedCommande}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                         <v-divider class="mb-3" v-if="factureDetail.usermodified != null"></v-divider>
                                                                        <v-layout row v-if="factureDetail.usermodified != null">
                                                                            <v-flex xs6>Modifié par</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.usermodified}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout  class="mb-3" row v-if="factureDetail.idContrat">
                                                                            <v-flex xs6>Contrat prestataire</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                contrat-{{factureDetail.idContrat}}
                                                                            </v-flex>
                                                                        </v-layout>

                                                                         <v-layout row>
                                                                            <v-flex v-if="!factureDetail.imgCommande"  xs2 class="mr-2" >
                                                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                                                            </v-flex>
                                                                            <v-flex  v-else xs3 class="mr-3  elevation-23 ">
                                                                            <a :href="factureDetail.imgCommande"  target=_blank>
                                                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="factureDetail.imgCommande" ></v-avatar>
                                                                            </a>
                                                                        </v-flex>
                                                                        </v-layout>

                                                                    </v-flex>

                                                                    <v-flex xs6 class="text-xs-left"> <!--BAS-->


                                                                        <v-layout row>
                                                                            <v-flex xs6>Fournisseur</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.libelleFour}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <!-- <v-layout row>
                                                                            <v-flex xs6>Caisse</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                   {{factureDetail.libelleCaisse}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider> -->

                                                                        <v-layout row>
                                                                            <v-flex xs6>Conditions de paiement</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.modalite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Avance démarage %</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.avance}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Travaux</v-flex>
                                                                        <v-layout  v-if="factureDetail.travaux != null">
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.travaux}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-layout  v-if="factureDetail.idContrat != null">
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                            {{factureDetail.libelleTravaux}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row>
                                                                            <v-flex xs6>Initiateur de la commande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{factureDetail.demandeurCommande}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row v-if="factureDetail.idContrat == null">
                                                                            <v-flex xs6>Budget Travaux</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{ new Intl.NumberFormat().format(factureDetail.budgetTravaux) }}

                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider  v-if="factureDetail.idContrat == null" class="mb-3"></v-divider>
                                                                        <v-layout row v-if="factureDetail.idContrat == null" >
                                                                            <v-flex xs6>Montant decaisse Travaux</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{ new Intl.NumberFormat().format(factureDetail.mntTotalDecaisseTrx) }}

                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider  v-if="factureDetail.idContrat == null" class="mb-3"></v-divider>

                                                                        <v-layout row  v-if="factureDetail.idContrat == null" >
                                                                            <v-flex xs6>Ecart montant</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{ new Intl.NumberFormat().format(factureDetail.ecartBudgetTrx) }}

                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider  v-if="factureDetail.idContrat == null" class="mb-3"></v-divider>
                                                                        <v-layout row v-if="factureDetail.idContrat == null">
                                                                            <v-flex xs6>Etat budget travaux (si la facture est validée)</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                <el-tag
                                                                                        :type="(factureDetail.ecartBudgetTrx >= factureDetail.total) ? 'success' : 'danger'"
                                                                                        disable-transitions>
                                                                                    <span v-if="factureDetail.ecartBudgetTrx >= factureDetail.total">Dans le budget</span>
                                                                                    <span v-else>Hors budget</span>
                                                                                </el-tag>

                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider  v-if="factureDetail.idContrat == null" class="mb-3"></v-divider>
                                                                        <v-layout row v-if="listeRapports.length > 0 ">
                                                                            <v-flex xs6></v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                <v-tooltip top>
                                                                                    <v-btn slot="activator" icons color="primary" @click.stop="loadRapportTrx()" dark>
                                                                                        Liste des rapports
                                                                                        <v-icon right>assignment</v-icon>
                                                                                    </v-btn>Liste des rapports
                                                                                </v-tooltip>
                                                                            </v-flex>
                                                                        </v-layout>



                                                                        <v-layout row  v-if="factureDetail.compare == 2" >
                                                                            <v-flex xs6>Validé par le comparateur de prix</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                <a href="#"  target=_blank>
                                                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img src="static/validComparateur.png" ></v-avatar>
                                                                            </a>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                         <v-flex xs12 class="text-xs-right">

                                                                          <v-tooltip top>
                                                                              <v-btn
                                                                                  v-if="true"
                                                                                  slot="activator"
                                                                                  color="green"
                                                                                  @click="dialogDetailCmd = true"
                                                                                  dark
                                                                              > Consulter
                                                                                  <v-icon right>compare</v-icon>
                                                                              </v-btn>Voir la proprosition du comparateur de prix
                                                                              </v-tooltip>

                                                                          <!-- <v-tooltip top>
                                                                            <v-btn  class="mb-2 ml-5" style="margin-right: 100px"
                                                                              absolute
                                                                              slot="activator" dark fab large bottom right color="orange"
                                                                              @click="dialogDetailCmd = true">
                                                                              <v-icon>edit</v-icon>
                                                                            </v-btn>
                                                                            <span>Voir la proprosition du comparateur de prix</span>
                                                                        </v-tooltip> -->
                                                                         </v-flex>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Produits / Travaux
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <v-card>
                                                                 <v-flex xs12   >
                                                                    <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC): {{new Intl.NumberFormat().format(factureDetail.total)}}</b></v-chip>
                                                                </v-flex>
                                                                <v-flex xs12   >
                                                                       <v-layout row v-if="factureDetail.idContrat">
                                                                          <v-flex xs2 >
                                                                              <v-card-text class="text-xs-center">
                                                                                  <v-chip
                                                                                          label
                                                                                          outline
                                                                                          color="primary darken-1"
                                                                                          class="elevation-4"
                                                                                          style="width:100%"
                                                                                  >
                                                                                      <span class="subheading">Mnt Contrat : </span>
                                                                                      <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(factureDetail.mntEstime)}} </span>
                                                                                  </v-chip>
                                                                              </v-card-text>

                                                                          </v-flex>

                                                                          <v-flex xs3>
                                                                              <v-card-text class="text-xs-center">
                                                                                  <v-chip
                                                                                          label
                                                                                          outline
                                                                                          color="blue-grey darken-1"
                                                                                          class="elevation-4"
                                                                                          style="width:100%"
                                                                                  >
                                                                                      <span class="subheading">Devis / facture(s) déjà generée(s) : </span>
                                                                                      <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(factureDetail.mntFacture)}} </span>
                                                                                  </v-chip>
                                                                              </v-card-text>

                                                                          </v-flex>

                                                                          <v-flex xs4>
                                                                              <v-card-text class="text-xs-center">
                                                                                  <v-chip
                                                                                          label
                                                                                          outline
                                                                                          color="orange darken-1"
                                                                                          class="elevation-4"
                                                                                          style="width:100%"
                                                                                  >
                                                                                      <span class="subheading">Mnt à verser / évolution: </span>
                                                                                      <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(factureDetail.mntAVerse) }} / {{factureDetail.evolution}}% </span>
                                                                                  </v-chip>
                                                                              </v-card-text>
                                                                          </v-flex>

                                                                          <v-flex xs3>
                                                                              <v-card-text class="text-xs-center">
                                                                                  <v-chip
                                                                                          label
                                                                                          outline
                                                                                          color="red darken-1"
                                                                                          class="elevation-4"
                                                                                          style="width:100%"
                                                                                  >
                                                                                      <span class="subheading">Mnt restant: </span>
                                                                                      <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(factureDetail.mntRestant) }} </span>
                                                                                  </v-chip>
                                                                              </v-card-text>

                                                                          </v-flex>
                                                                      </v-layout>
                                                                </v-flex>
                                                                <v-layout row>
                                                                    <el-table :data="factureDetail.option" style="width: 100%">
                                                                        <el-table-column prop="produit" label="Designation" sortable> </el-table-column>
                                                                        <el-table-column  prop="prixUOld" label="Ancien prix unitaire">
                                                                                <template slot-scope="scope">
                                                                                   <v-chip label text-color="white" color="red">
                                                                                       {{ new Intl.NumberFormat().format(scope.row.prixUOld)}}
                                                                                      </v-chip>
                                                                            </template>
                                                                        </el-table-column>
                                                                        <el-table-column  prop="prix" label="Prix unitaire" v-if="factureDetail.idContrat == null">
                                                                            <template slot-scope="prop">
                                                                               {{ new Intl.NumberFormat().format(prop.row.prix)}}
                                                                            </template>
                                                                        </el-table-column>
                                                                         <el-table-column  prop="unite" label="Unité"></el-table-column>
                                                                        <el-table-column  v-if="factureDetail.idContrat == null" prop="qte" label="Quantite"> </el-table-column>
                                                                        <el-table-column  prop="remise" label="Remise(%)"></el-table-column>
                                                                        <el-table-column  prop="tva" label="Tva(%)"></el-table-column>

                                                                        <el-table-column    prop="total" label="Total commande / Montant prestataire">
                                                                            <template  slot-scope="prop">
                                                                              {{new Intl.NumberFormat().format(prop.row.total)}}
                                                                            </template>
                                                                        </el-table-column>

                                                                        <!-- <el-table-column  v-if="factureDetail.idContrat == null" prop="totalBudget" label="Total budget mensuel">
                                                                            <template  slot-scope="prop">
                                                                             {{new Intl.NumberFormat().format(prop.row.totalBudget)}}
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column  prop="mntTotFactProd" label="Total Facture validée">
                                                                        <template  slot-scope="prop">
                                                                           {{new Intl.NumberFormat().format(prop.row.mntTotFactProd)}}
                                                                        </template>
                                                                       </el-table-column> -->


                                                                        <!-- <el-table-column   v-if="factureDetail.idContrat == null" prop="ecartBudget" label="Ecart(mnt disponible budget)">
                                                                            <template  slot-scope="prop">
                                                                              {{new Intl.NumberFormat().format(prop.row.ecartBudget )}}
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column  v-if="factureDetail.idContrat == null"  prop="etatBudget" label="Etat budget(si facture validée)">
                                                                            <template  slot-scope="prop">
                                                                                <el-tag
                                                                                        :type="prop.row.etatBudget == 'Dans le budget' ? 'success' : 'danger'"
                                                                                        disable-transitions>
                                                                                        <span >{{prop.row.etatBudget}}</span>
                                                                                </el-tag>
                                                                            </template>
                                                                        </el-table-column> -->

                                                                    </el-table>
                                                                </v-layout>
                                                                <br>
                                                            </v-card>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
            <v-tooltip top>
                <v-btn  class="mb-5" style="margin-right: 100px"
                   absolute
                   slot="activator" dark fab large bottom right color="red"
                   @click="dialogConfirmRefus = true">
                   <v-icon>close</v-icon>
                </v-btn>
                <span>Refuser la demande</span>
            </v-tooltip>

            <v-tooltip top>
                <v-btn class="mb-5 ml-5"
                   absolute
                   slot="activator"
                   dark
                   fab
                   large
                   bottom
                   right
                   color="green"
                   @click="dialogConfirm = true">
                   <v-icon>done</v-icon>
                </v-btn>
                <span>Valider la demande</span>
            </v-tooltip>

        </v-dialog>

         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
                <v-card>
                    <v-card-title class="headline">Validation de devis / facture</v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 class="mb-2">
                                <el-alert
                                    title="Voulez vous Refuser cette facture ?"
                                    :closable="false"
                                    show-icon
                                    type="error">
                                </el-alert>
                            </v-flex>
                            <v-flex xs12>
                                <p class="grey--text font-weight-thin body-1">FACTURE</p>
                                <p class="black--text .font-weight-regular subheading" >FACT-{{factureDetail.idFact}}</p>
                            </v-flex>
                            <v-flex xs12>
                                <el-form  id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                                    <v-flex xs12 >
                                        <el-form-item style="width:100%" label="Commentaire" prop="rapportRefus" >
                                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                                        </el-form-item >
                                    </v-flex>
                                </el-form>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" dark @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                        <v-btn color="red darken-1" dark @click.native="SubmitRefusDevis()">Refuser</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
         </v-layout>

         <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650">
                <v-card>
                    <v-card-title class="headline">Validation de devis / facture</v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 class="mb-2">
                                <el-alert
                                    title="Voulez vous valider le facture ?"
                                    :closable="false"
                                    show-icon
                                    type="success">
                                </el-alert>
                            </v-flex>
                            <v-flex xs12>
                                <p class="grey--text font-weight-thin body-1">FACTURE</p>
                                <p class="black--text .font-weight-regular subheading" >FACT-{{factureDetail.idFact}}</p>
                            </v-flex>
                            <el-form :model="formValidate" :inline="true" ref="formValidate" label-width="150px" class="demo-ruleForm demo-form-inline">
                          <v-layout row>
                                    <v-flex xs6 class="mr-1" >
                                      <el-form-item prop="choix" label="Type de règlement" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},
                                        ]">
                                        <el-select @change="changeReglement()" v-model="formValidate.choix" placeholder="Votre choix">
                                          <el-option label="En Espèce" value="1"></el-option>
                                          <el-option label="Par Chèque" value="2"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>

                                    <v-flex xs6 class="mr-1" v-if="formValidate.choix == 2" >
                                      <el-form-item prop="banque" label="La banque" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},]">
                                        <el-select v-model="formValidate.banque" placeholder="La banque">
                                          <el-option v-for="item in listBanque" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>

                                    <v-flex xs6 class="mr-1" v-if="formValidate.choix == 1"  >
                                      <el-form-item prop="banque" label="La Caisse" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},]">
                                        <el-select v-model="formValidate.banque" placeholder="La caisse">
                                          <el-option v-for="item in listCaisse" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>
                                  </v-layout>
                            </el-form>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" dark @click.native="dialogConfirm = false">Annuler</v-btn>
                        <v-btn color="green darken-1" dark  @click.native="SubmitValideDevis()">Confirmer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <!--DIALLOG LISTE RAPPORT-->
        <v-dialog v-model="dialogListeRapport" fullscreen hide-overlay transition="dialog-bottom-transition" >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title >LISTE DES RAPPORTS DES TRAVAUX : {{factureDetail.travaux}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogListeRapport = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <!-- LISTE DES RAPPORT TRAVAUX-->
                    <ListeRapportTrx :libTrx="factureDetail.travaux"  :IddetailTravaux="factureDetail.idTravaux"   :listeRapportTrx= "listeRapports"  > </ListeRapportTrx>
                    <!-- LISTE DES RAPPORT TRAVAUX -->
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--FIN DIALLOG LISTE RAPPORT-->

        <v-dialog v-model="dialogDetailCmd" max-width="90%" :overlay="true" scrollable persistent>
       <!-- <v-dialog v-model="dialogDetailCmd"  scrollable fullscreen hide-overlay transition="dialog-bottom-transition"> -->
          <v-card >
            <v-toolbar style="flex: 0 0 auto;" dark class="primary">
              <v-toolbar-title>
                <span >Détail de la commande analyser par le comparateur </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="closeCompar()" dark><v-icon>close</v-icon> </v-btn>
            </v-toolbar>
                 <v-alert  v-if="commandeDeriv.length == 0 && commandeDerivDeux.length == 0" class="elevation-1 subheading mb-1 mt-5" color="warning" :value="true" icon="priority_high" outline>
                    Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs,
                      Pour une meilleur performance du comparateur, veuillez constitué une base importante de fournisseurs.
                    </v-alert>
            <v-card-text>
                <v-layout row class="mb-4">


                    <v-flex xs12 class="mb-3" >

                        <v-card v-if="commandeDeriv.length != 0">
                            <v-toolbar class="text-xs-center"   color="cyan" dark   >
                                <v-toolbar-title>COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT TOUS LES PRODUITS DE LA COMMANDE</v-toolbar-title>
                            </v-toolbar>
                            <v-card-title class="text-xs-center"   >
                              <v-container>
                                  <v-layout wrap class="mb-2">

                                    <v-flex xs4 >
                                        <v-chip color="orange" text-color="white" style="font-size:18px">
                                          <v-avatar  class="orange darken-4"> {{nbCommandeSug}} </v-avatar>
                                          Fournisseur(s) proprosant des meilleurs prix pour ce(s) produit(s)
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                              </v-container>



                                <v-container>
                                  <v-layout v-for="(fourn , indF) in commandeDeriv" :key="indF" >
                                    <v-flex  class="mb-4 pl-3 pt-3 mr-3 elevation-5" xs12    >
                                        <v-flex xs8 class="mb-2" >
                                            <v-chip label outline color="green darken-1"  class="elevation-4 text-xs-left" style="width:100%">
                                                <span class="subheading">Fournisseur : &nbsp; &nbsp;  </span> <span class="title text-xs-left"  >   {{fourn.fournisseur}}</span>
                                            </v-chip>
                                            <v-chip label outline   color="green darken-1"  class="elevation-4" style="width:100%">
                                                <span class="subheading">Total HT: &nbsp; &nbsp; </span> <span class="title">    {{ new Intl.NumberFormat().format(fourn.mntTotalHt) }}  Fcfa </span>
                                            </v-chip>
                                            <v-chip label outline   color="green darken-1"  class="elevation-4" style="width:100%">
                                                <span class="subheading">Total TTC:&nbsp; &nbsp;  </span> <span class="title">    {{ new Intl.NumberFormat().format(fourn.mntTotal) }}  Fcfa </span>
                                            </v-chip>
                                        </v-flex>



                                        <v-flex xs12>
                                            <el-table :data="fourn.produits"  >
                                                <el-table-column prop="libelleProduit" label="Libelle" > </el-table-column>
                                                <el-table-column prop="qteProd" label="Quantite" > </el-table-column>
                                                <el-table-column prop="prixUFormat" label="Prix Unitaire (Fcfa)" ></el-table-column>
                                                <el-table-column prop="unite" label="Unite" ></el-table-column>
                                                <el-table-column prop="tva" label="Tva" ></el-table-column>
                                                <el-table-column prop="mntTotalHt" label="Total HT (Fcfa)" >
                                                    <template slot-scope="scope">
                                                        <el-tag >  {{scope.row.mntTotalFormatHt }}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="mntTotal" label="Total TTC (Fcfa)" >
                                                    <template slot-scope="scope">
                                                        <el-tag >  {{scope.row.mntTotalFormat }}</el-tag>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-flex>
                                        <v-divider class="mb-3" ></v-divider>
                                    </v-flex>
                                  </v-layout>
                                </v-container>

                            </v-card-title>
                        </v-card>
                        <br/>

                        <v-card v-if="commandeDerivDeux.length != 0">
                            <v-toolbar class="text-xs-center"   color="teal" dark   >
                                <v-toolbar-title>COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT CERTAINS PRODUITS DE LA COMMANDE</v-toolbar-title>
                            </v-toolbar>
                            <v-card-title class="text-xs-center"   >
                              <v-container>
                                  <v-layout wrap class="mb-2">
                                    <v-flex xs4 >
                                        <v-chip color="orange" text-color="white" style="font-size:18px">
                                          <v-avatar  class="orange darken-4"> {{nbCommandeSugDeux}} </v-avatar>
                                          Fournisseur(s) proprosant des meilleurs prix pour ce(s) produit(s)
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                              </v-container>



                                <v-container>
                                  <v-layout v-for="(fourn , indF) in commandeDerivDeux" :key="indF" >
                                    <v-flex  class="mb-4 pl-3 pt-3 mr-3 elevation-5" xs12    >
                                        <v-flex xs8 class="mb-2" >
                                            <v-chip label outline color="green darken-1"  class="elevation-4 text-xs-left" style="width:100%">
                                                <span class="subheading">Fournisseur :&nbsp; &nbsp;  </span> <span class="title text-xs-left"  >   {{fourn.fournisseur}}</span>
                                            </v-chip>
                                            <v-chip label outline   color="green darken-1"  class="elevation-4" style="width:100%">
                                                <span class="subheading">Total HT: &nbsp; &nbsp; </span> <span class="title">    {{ new Intl.NumberFormat().format(fourn.mntTotalHt) }}  Fcfa </span>
                                            </v-chip>
                                            <v-chip label outline   color="green darken-1"  class="elevation-4" style="width:100%">
                                                <span class="subheading">Total TTC: &nbsp; &nbsp; </span> <span class="title">    {{new Intl.NumberFormat().format(fourn.mntTotal) }}  Fcfa </span>
                                            </v-chip>
                                        </v-flex>



                                        <v-flex xs12>
                                            <el-table :data="fourn.produits"  >
                                                <el-table-column prop="libelleProduit" label="Libelle" > </el-table-column>
                                                <el-table-column prop="qteProd" label="Quantite" > </el-table-column>
                                                <el-table-column prop="prixUFormat" label="Prix Unitaire (Fcfa)" ></el-table-column>
                                                <el-table-column prop="unite" label="Unite" ></el-table-column>
                                                <el-table-column prop="tva" label="Tva" ></el-table-column>
                                                <el-table-column prop="mntTotalHt" label="Total HT (Fcfa)" >
                                                  <template slot-scope="scope">
                                                      <el-tag >  {{scope.row.mntTotalFormatHt}}</el-tag>
                                                  </template>
                                              </el-table-column>
                                              <el-table-column prop="mntTotal" label="Total TTC (Fcfa)" >
                                                  <template slot-scope="scope">
                                                      <el-tag >   {{scope.row.mntTotalFormat}}</el-tag>
                                                  </template>
                                              </el-table-column>
                                            </el-table>
                                        </v-flex>
                                        <v-divider class="mb-3" ></v-divider>
                                    </v-flex>
                                  </v-layout>
                                </v-container>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-card-text>
          </v-card>
          <v-tooltip top>
                <v-btn class="mb-5" style="margin-right: 30px" absolute @click.stop="closeCompar()" slot="activator" dark fab large bottom right >
                <v-icon>close</v-icon>
                </v-btn>
                <span>Femer</span>
            </v-tooltip>
        </v-dialog>


	</div>
</template>


<script>
    import Loading from '@/components/Loading';
    import ListeRapportTrx from '@/components/rapport/ListeRapportTrx';
    export default {
	components:{ Loading, ListeRapportTrx },
        name: "ModalValidationFacture",
        // props:["show","factureDetail","totalFact",],
          props:{
            show: {
                type: Boolean
            },
            factureDetail: {
                type: Array
            },
             totalFact: {
                type: Number
            },
            infOrenseigner:{
               type: Array,
            },
            commandeDeriv: {
                type: Array,
                required: false
            },
            commandeDerivDeux: {
               type: Array,
            },
            mntTotalCmd: {
                type: String
            },
            nbCommandeSug:{
                type: Number
            },
            nbCommandeSugDeux:{
                type: Number
            },
            typeCommande: {
                type: Number,
                default: 1, //1=>Commande avec des options commandes//2=> commande avec des optionBesoins

            },
            listCaisse: {
               type: Array,
            },
            listBanque: {
               type: Array,
            },

        },
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit:[],
            totalTTC:0,
            formRapport:{},
            dialogVisible: false,
            dialogImageUrl: '',
            mntEstimeContrat : 0,
            mntFactureGenere : 0,
            mntAVerserContrat : 0,
            evolutionContrat : 0,
            listCaisse: [],
            factureDetail: [],
            listBanque: [],
            image1: "/static/img-doc.png",
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            dialogDetailCmd: false,
            formRefus:{},
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            },
             formValidate: {
              choix: '',
              banque:'',
            },
             listeRapports : [],
             dialogListeRapport: false
         }
        },

        computed:{
        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
               }
            }
        },

        methods:
        {

            successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
            closeDialog(){
                this.$emit('close',this.factureDetail.idFact,"factureFour")
            },
             closeCompar()
             {
                // this.$emit('close')
                this.dialogDetailCmd = false
            },
            changeReglement () {
                if (this.formValidate.choix == 2) {
                    this.formValidate.banque = ''
                } else{
                  this.formValidate.banque = ''
                }
            },
            loadDevisConstat (){
                this.loading = true
                let url = this.domaine + 'demande_maintenance/devis/constat/'+this.factureDetail.idDemande
                this.$http.get(url).then(response => {
                    this.tableProduit = response.body.tableProduit
                    this.formRapport.rapport = response.body.rapport
                    this.totalTTC = response.body.total
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
                })
            },
            handleRemove(file, fileList) {


            },
            handleSuccess(response, file, fileList){

                this.fileList.push(file)
            },
            handlePictureCardPreview(file, fileList) {

                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imprimerDetail(){
                let url = this.domaine+"demande_maintenance/imprimerPDF/demande/"+this.user.id+"/"+this.factureDetail.idDemande
                window.open(url)
            },
            SubmitValideDevis(){
               if (
                  this.formValidate.choix == null ||
                  this.formValidate.banque == "undefined" ||
                  this.formValidate.banque == ""
                ) {
                  this.$message.error("Remplissez les champs obligatoires")
                  return;
                }

                this.loading = true
                let url = this.domaine + 'fournisseur/valider/facture'

                let data = new FormData()
                data.append("id",  this.factureDetail.idFact)
                data.append("banque",  this.formValidate.banque)


                data.append("idUser",  this.user.id)
                data.append("remarque", " ")
                data.append("decision",  1)
                this.$http.post(url,data).then(response => {
                    this.loading = false
                    this.successNotif(response.body.message)
                    this.dialogConfirm = false
                    this.closeDialog();
                },errResp=>{
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de la facture")
                })
            },
            SubmitRefusDevis(){
                this.loading = true
                let url = this.domaine + 'fournisseur/valider/facture'

                let data = new FormData()
                data.append("id",  this.factureDetail.idFact)
                data.append("idUser",  this.user.id)
                data.append("remarque", this.formRefus.rapport)
                data.append("decision", 2)
                this.$http.post(url,data).then(response => {
                    this.loading = false
                    this.successNotif(response.body.message)
                    this.dialogConfirmRefus = false
                    this.closeDialog();
                }, errResp=>{
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de la facture")
                })
            },
            loadRapportTrx () {
                this.loading = true
                let url = this.domaine + 'journal/travaux/'+this.factureDetail.idTravaux
                this.$http.get(url).then(response => {
                        this.listeRapports = response.body.journaux
                        this.dialogListeRapport = true;
                        this.loading = false;
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error('Echec lors du chargement des Journaux')
                    })

            },
        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationFacture.vue